import * as React from 'react';
import { Route } from 'react-router-dom';
import AlarmList from '../components/AlarmList/AlarmList';
import CreateReviews from '../components/CreateReviews/CreateReviews';

export default [
  <Route exact path='/alarmlist' component={AlarmList} />,
  <Route exact path='/createreivews' component={CreateReviews} />,
];
